module.exports = __webpack_public_path__ + "img/header-red-square-bottom.1166b8a2.svg";